import { useList } from './List.h'
import { usePermission } from '@shared/hooks/permissions'

import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import LinearProgress from '@mui/material/LinearProgress'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import MoreVertIcon from '@mui/icons-material/MoreVert'

export default function Data() {
    const {
        query,
        anchor,
        setAnchor,
        setInstance,
        handleOpenEstimations,
        handleDelete,
        handleFetchInstance,
    } = useList()
    const { hasPermission } = usePermission()

    return query.isFetching
        ? <LinearProgress />
        : query.error
            ? <Typography className='centerized'>حدث خطأ</Typography>
            : (
                <>
                    <List sx={{height: '100%'}}>
                        {query.data.length === 0 &&
                            <Typography className='centerized'>لا توجد بيانات</Typography>
                        }
                        {query.data.map(office => (
                            <ListItem
                                key={office.id}
                                disablePadding
                                onClick={() => setInstance(office)}
                                secondaryAction={(hasPermission('change_office') && hasPermission('delete_office')) &&
                                    <IconButton onClick={e => setAnchor(e.currentTarget)}>
                                        <MoreVertIcon />
                                    </IconButton>
                                }
                            >
                                <ListItemButton onClick={() => handleOpenEstimations(office)}>
                                    <ListItemText
                                        primary={office.name}
                                        secondary={`المقايسات: ${office.estimations_count}`}
                                    />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                    <Menu
                        open={!!anchor}
                        anchorEl={anchor}
                        onClose={() => setAnchor(null)}
                    >
                        {hasPermission('delete_office') && <MenuItem onClick={handleDelete}>حذف</MenuItem>}
                        {hasPermission('change_office') && <MenuItem onClick={handleFetchInstance}>تعديل</MenuItem>}
                    </Menu>
                </>
            )
}